// date: 2021-12-17  time: 13:00
const getDebtISOTime = (date: string, time: string) => {
  const tzo = -new Date().getTimezoneOffset();
  const diff = tzo >= 0 ? '+' : '-';
  return `${date}T${time}:00${diff}${String(tzo / 60).padStart(2, '0')}:${String(tzo % 60).padStart(2, '0')}`;
};

export default getDebtISOTime;
